import React from 'react';
import { Typography, Box } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { 
  Cpt1Editor, 
  Cpt2Editor, 
  Cpt3Editor, 
  Cpt4Editor, 
  Cpt5Editor, 
  Cpt6Editor, 
  Cpt7Editor, 
  Cpt8Editor 
} from '../../fieldEditors/contractEditors';

const MultiplierSection: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        CPT Multipliers
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure multipliers for different CPT procedure types.
      </Typography>
      
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { 
          xs: '1fr', 
          sm: '1fr 1fr', 
          md: '1fr 1fr 1fr 1fr' 
        }, 
        gap: 2 
      }}>
        <Cpt1Editor />
        <Cpt2Editor />
        <Cpt3Editor />
        <Cpt4Editor />
        <Cpt5Editor />
        <Cpt6Editor />
        <Cpt7Editor />
        <Cpt8Editor />
      </Box>
    </SectionPaper>
  );
};

export default MultiplierSection;